import { render, staticRenderFns } from "./Style.vue?vue&type=template&id=4b4a833c&scoped=true"
import script from "./Style.vue?vue&type=script&lang=js"
export * from "./Style.vue?vue&type=script&lang=js"
import style0 from "./Style.vue?vue&type=style&index=0&id=4b4a833c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4a833c",
  null
  
)

export default component.exports